document.addEventListener('DOMContentLoaded', () => {
  const filters = document.querySelectorAll('[data-nutrition-filters] [data-filter]');
  const groups = document.querySelectorAll('[data-nutrition-group]');
  if (!filters.length || !groups.length) return;

  filters.forEach((btn) => {
    btn.addEventListener('click', () => {
      filters.forEach((b) => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');

      const filter = btn.getAttribute('data-filter');
      groups.forEach((group) => {
        group.hidden = filter !== 'all' && group.getAttribute('data-line') !== filter;
      });
    });
  });
});
